

import React, { useEffect, useState } from "react";
import { Card, CardHeader, CardBody, Row, Col, CardTitle, Alert, Badge, Tooltip } from "reactstrap";
import { Line } from "react-chartjs-2";
import { chartOptions, buildChartV2 } from "../../helpers/utils";
import useToken from "../../helpers/useToken"
import useTimeZone from "../../helpers/useTimeZone"
import TMHLoader from "../TMHLoader/TMHLoader"

export default function NotificationActiveChart() {
    const [datasets, setDatasets] = useState()
    const [labels, setLabels] = useState([])
    const [info, setInfo] = useState()
    const [notificationInfo, setNotificationInfo] = useState()
    const [isLoading, setIsLoading] = useState(false)
    const { token } = useToken()
    const { timeZone } = useTimeZone()

    useEffect(() => {
        async function initData() {
            console.log('NotificationActiveChart: update data')
            setIsLoading(true)
            var myHeaders = new Headers();
            myHeaders.append("Content-Type", "application/json");
            myHeaders.append("Cache-Control", "no-cache");
            myHeaders.append("Access-Token", token);

            var requestOptions = {
                method: 'GET',
                headers: myHeaders,
            }

            var params = new URLSearchParams({
                'timezone_offset_minutes': timeZone * -60,
                'number_last_days': 7
            })

            fetch(process.env.REACT_APP_BASE_URL + "dashboard/tmh_profile_active_user_chart?" + params, requestOptions)
                .then((response) => {
                    return new Promise((resolve) => response.json()
                        .then((json) => resolve({
                            status: response.status,
                            ok: response.ok,
                            json,
                        })))
                }).then(
                    async (result) => {
                        var json = result.json
                        if (result.ok) {
                            setDatasets(json?.data.datasets)
                            setLabels(json?.data.labels)
                            setInfo(json?.data.info)
                            setNotificationInfo(json?.data.notification_info)
                            setIsLoading(false)
                        }
                        else {
                            console.log(result.json.message)
                            setIsLoading(false)
                        }
                    }
                )
        }

        initData()
    }, [setIsLoading, token, timeZone])

    return (
        <TMHLoader active={isLoading}>

            <Row>
                <Col md="12">
                    <Card className="card-chart">
                        <CardHeader>
                            <Row>
                                <Col className="text-left" sm="6">
                                    <h5>Connected Roku User By Day</h5>

                                </Col>
                            </Row>
                        </CardHeader>
                        <CardBody>
                            <div className="chart-area">
                            <div className="chart-area">
                                    {
                                        datasets &&<Line
                                            data={buildChartV2(labels, datasets, ['Current', 'Last ' + String(7) +' days ago', 'New', 'New - Last ' + String(7) +' days ago'])}
                                            options={chartOptions(true)} />
                                    }
                                </div>
                            </div>
                        </CardBody>
                    </Card>
                </Col>
            </Row>

            <Row>
                <Col sm="6" md="6" lg="2">
                    <Card>
                        <CardHeader>
                            <CardTitle className="text-info" tag="h4">
                                 Connected Roku (total / new)
                            </CardTitle>
                            <Alert color="warning">
                                <span>
                                    <i className="tim-icons icon-bullet-list-67 text-success" /> Total <Badge color="default" pill>{info?.total}</Badge>
                                </span>
                            </Alert>
                            <Alert color="success">
                                <i className="tim-icons icon-bullet-list-67 text-success" />  Today <Badge color="default" pill>{info?.today[0]} / {info?.today[1]}</Badge>
                            </Alert>
                            <Alert color="danger">
                                <i className="tim-icons icon-bullet-list-67 text-success" />  Yesterday <Badge color="default" pill>{info?.yesterday[0]} / {info?.yesterday[1]}</Badge>
                            </Alert>
                        </CardHeader>
                    </Card>
                </Col>
                <Col sm="6" md="6" lg="2">
                    <Card>
                        <CardHeader>
                            <CardTitle className="text-info" tag="h4">
                                SENT NOTIFS (total / notification on)
                            </CardTitle>
                            <Alert color="warning">
                                <span>
                                    <i className="tim-icons icon-bullet-list-67 text-success" /> Total <Badge color="default" pill>{notificationInfo?.total[0]}/{notificationInfo?.total[1]}</Badge>
                                </span>
                            </Alert>
                            <Alert color="success">
                                <i className="tim-icons icon-bullet-list-67 text-success" />  Today <Badge color="default" pill>{notificationInfo?.today[0]} / {notificationInfo?.today[1]}</Badge>
                            </Alert>
                            <Alert color="danger">
                                <i className="tim-icons icon-bullet-list-67 text-success" />  Yesterday <Badge color="default" pill>{notificationInfo?.yesterday[0]} / {notificationInfo?.yesterday[1]}</Badge>
                            </Alert>
                        </CardHeader>
                    </Card>
                </Col>
            </Row>
        </TMHLoader>
    )
}